import React, { Component, PropTypes } from 'react';
import { StyledSummarySelect } from '../styles';

class OfferTypeSelect extends Component {
  static propTypes = {
    items: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ]),
    onSelect: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    textKey: PropTypes.string.isRequired,
    valueKey: PropTypes.string.isRequired,
    className: React.PropTypes.string,
    disabled: PropTypes.bool,
  };
  static defaultProps = {
    value: 'N/A',
    className: '',
    disabled: false,
    items: []
  };
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.onFocusIn = this.onFocusIn.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
  }

  componentDidMount() {
    document.querySelector('select.offer-type-dropdown').addEventListener('blur', this.onFocusOut);
    document.querySelector('select.offer-type-dropdown').addEventListener('focusout', this.onFocusOut);
  }

  /* eslint-disable */
  onFocusIn() {
    const { items, value } = this.props;
    const selectOptions = document.querySelector('select.offer-type-dropdown').options;
    for (let x = 0, y = selectOptions.length; x < y; x++) {
      let menuItem = items.menuOptions[x];
      selectOptions[x].text = menuItem.text;
      selectOptions[x].value = menuItem.value;
      if (menuItem.value === value.value) {
        selectOptions[x].selected = true;
      }
    }
  }
  onFocusOut() {
    const { items, value } = this.props;
    const selectOptions = document.querySelector('select.offer-type-dropdown').options;
    for (let x = 0, y = selectOptions.length; x < y; x++) {
      let displayItem = items.displayOptions[x];
      selectOptions[x].text = displayItem.text;
      selectOptions[x].value = displayItem.value;
      if (displayItem.value === value.value) {
        selectOptions[x].selected = true;
      }
    }
  }
  /* eslint-enable */
  handleChange(event) {
    const { onSelect } = this.props;
    onSelect(event.target);
    this.onFocusOut();
    document.querySelector('select.offer-type-dropdown').blur();
  }
  render() {
    const {
      value,
      items,
      textKey,
      valueKey,
      className,
      disabled,
    } = this.props;
    const ensureItems = items.displayOptions || [];
    const classes = `summary-select  ${className}`;
    return ( //eslint-disable-next-line
      <StyledSummarySelect className={classes} value={value} onChange={this.handleChange} disabled={disabled} onFocus={this.onFocusIn}>
        {ensureItems.map(item => (
          <option
            key={item.key}
            id={item.id}
            value={item[valueKey]}
            className={item.className}
          >{item[textKey]}</option>
        ))}
      </StyledSummarySelect>
    )
  }
}

export default OfferTypeSelect;



/** WEBPACK FOOTER **
 ** ./src/components/SelectBox/OfferTypeSelect/index.js
 **/